"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));
var _CardActions = _interopRequireDefault(require("@material-ui/core/CardActions"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _GroupAdd = _interopRequireDefault(require("@material-ui/icons/GroupAdd"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Carousel = _interopRequireDefault(require("../Carousel/Carousel"));
var _style = require("../../utils/style");
var _useBoatLowestPrice = require("../../hooks/useBoatLowestPrice");
var _useBoatOrderedImages = require("../../hooks/useBoatOrderedImages");
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("../..");
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _Star = _interopRequireDefault(require("@material-ui/icons/Star"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
    mixins = _ref.mixins,
    typography = _ref.typography,
    spacing = _ref.spacing;
  return {
    boatRoot: {
      transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      "&:hover": {
        transform: "scale(1.03)"
      }
    },
    actionArea: {
      position: "relative"
    },
    capacityBlock: {
      background: "rgba(0,0,0,0.17)",
      pointerEvents: "none"
    },
    media: {
      height: 0,
      paddingTop: "56.25%" // 16:9
    },

    mediaInner: {
      position: "absolute!important",
      top: 0,
      width: "100%"
    },
    actions: {
      color: palette.common.white,
      position: "absolute",
      bottom: 0,
      right: 0,
      textAlign: "right"
    },
    body: _objectSpread(_objectSpread({}, mixins.truncate), {}, {
      lineClamp: 2,
      boxOrient: "vertical",
      display: "box",
      whiteSpace: "inherit",
      overflow: "hidden",
      height: (0, _style.remToPxUnit)(typography.body2.fontSize, typography.htmlFontSize) * typography.body2.lineHeight * 2
    }),
    extras: {
      display: "flex",
      height: 20,
      alignItems: "center",
      "& p": _objectSpread(_objectSpread({}, mixins.truncate), {}, {
        color: palette.success.main,
        fontWeight: 500
      }),
      "& svg": {
        fontSize: 18,
        marginRight: 6,
        color: palette.success.main
      }
    },
    footer: {
      paddingTop: 0
    },
    itemFooter: {
      marginBottom: "-".concat(spacing(1), "px")
    }
  };
});
function BoatCard(_ref2) {
  var boat = _ref2.boat,
    LinkComponent = _ref2.LinkComponent,
    item = _ref2.item,
    booking = _ref2.booking,
    useNoneGatsbyImage = _ref2.useNoneGatsbyImage,
    currency = _ref2.currency,
    hidePrice = _ref2.hidePrice,
    mediaLoadType = _ref2.mediaLoadType,
    onClick = _ref2.onClick;
  var name = boat.name,
    oneLiner = boat.oneLiner,
    boatTypes = boat.boatTypes,
    capacity = boat.capacity,
    calculatedRating = boat.calculatedRating,
    calculatedLowestPrice = boat.calculatedLowestPrice;
  var _useStyles = useStyles(),
    boatRoot = _useStyles.boatRoot,
    actionArea = _useStyles.actionArea,
    media = _useStyles.media,
    capacityBlock = _useStyles.capacityBlock,
    mediaInner = _useStyles.mediaInner,
    actions = _useStyles.actions,
    body = _useStyles.body,
    footer = _useStyles.footer,
    itemFooter = _useStyles.itemFooter,
    extras = _useStyles.extras;
  var boatImages = (0, _react.useMemo)(function () {
    return (0, _useBoatOrderedImages.getOrderedBoatImages)(boat);
  }, [boat]);
  var filteredBoatTypes = (0, _react.useMemo)(function () {
    return boatTypes.filter(function (bt) {
      return bt.path;
    });
  }, [boatTypes]);
  var boatPrice = (0, _react.useMemo)(function () {
    if (calculatedLowestPrice) {
      return calculatedLowestPrice;
    }
    return (0, _useBoatLowestPrice.getLowestPriceFn)(boat, _useBoatLowestPrice.forHrs);
  }, [calculatedLowestPrice, boat]);
  return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    raised: true,
    elevation: 2,
    className: boatRoot
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: actionArea
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: media
  }, /*#__PURE__*/_react["default"].createElement(_Carousel["default"], {
    className: mediaInner,
    media: boatImages,
    useNoneGatsbyImage: useNoneGatsbyImage,
    imageLoading: mediaLoadType ? mediaLoadType : "lazy"
  })), /*#__PURE__*/_react["default"].createElement(_CardActions["default"], {
    className: actions
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: capacityBlock,
    color: "inherit",
    size: "large",
    startIcon: /*#__PURE__*/_react["default"].createElement(_GroupAdd["default"], null)
  }, capacity))), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], null, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "caption",
    color: "textSecondary",
    component: "p",
    noWrap: true,
    gutterBottom: true
  }, filteredBoatTypes.length ? filteredBoatTypes.map(function (bt, i) {
    return /*#__PURE__*/_react["default"].createElement(LinkComponent, {
      className: "boat-type-link",
      key: i,
      path: bt.path,
      color: "textSecondary"
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "caption",
      color: "textSecondary",
      component: "span"
    }, bt.name, i !== filteredBoatTypes.length - 1 && " - "));
  }) : "--"), calculatedRating && calculatedRating > 0 && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Star["default"], {
    fontSize: "small",
    color: "primary"
  }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2"
  }, calculatedRating.toLocaleString(undefined, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }), "/5"))), /*#__PURE__*/_react["default"].createElement(LinkComponent, {
    boat: boat
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    color: "primary",
    component: "h2",
    noWrap: true
  }, name || "----")), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: body,
    component: "p"
  }, oneLiner || "----"), /*#__PURE__*/_react["default"].createElement("div", {
    className: extras
  }, boat.cardExtraOne && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Check["default"], null), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    component: "p",
    noWrap: true
  }, boat.cardExtraOne))), /*#__PURE__*/_react["default"].createElement("div", {
    className: extras
  }, boat.cardExtraTwo && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Check["default"], null), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    component: "p",
    noWrap: true
  }, boat.cardExtraTwo)))), !hidePrice && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, item !== null && item !== void 0 && item.price ? /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
    className: (0, _classnames["default"])(footer, itemFooter)
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    xs: 12,
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1",
    color: "textPrimary",
    component: "p"
  }, "Total:", " ", /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6",
    color: "primary",
    component: "span",
    style: {
      fontWeight: 600
    }
  }, (0, _.toCurrency)(item.price, currency), "*", " ")), (booking === null || booking === void 0 ? void 0 : booking.cruiseDate) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1",
    color: "textPrimary",
    component: "p"
  }, "Cruise Date:", " ", /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: "primary",
    component: "span",
    style: {
      fontWeight: 600
    }
  }, (0, _moment["default"])(booking === null || booking === void 0 ? void 0 : booking.cruiseDate).format("ll"))), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1",
    color: "textPrimary",
    component: "p"
  }, "Cruise Time:", " ", /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: "primary",
    component: "span",
    style: {
      fontWeight: 600
    }
  }, (0, _moment["default"])(booking === null || booking === void 0 ? void 0 : booking.cruiseDate).format("hh:mm a")))), item.hours && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1",
    color: "textPrimary",
    component: "p"
  }, "Hour(s):", " ", /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6",
    color: "primary",
    component: "span",
    style: {
      fontWeight: 600
    }
  }, item.hours)), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    align: "right"
  }, "*additional fees apply"))))) : /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
    className: footer
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    alignItems: "center",
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    xs: 12,
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    component: "p"
  }, "From:", " ", /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    color: "textPrimary",
    component: "b",
    style: {
      fontWeight: 600
    }
  }, (0, _.toCurrency)(boatPrice, currency)), "/hr")), onClick && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    xs: 12,
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "contained",
    color: "primary",
    onClick: onClick
  }, "View Boat"))))));
}
BoatCard.propTypes = {
  boat: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    oneLiner: _propTypes["default"].string,
    capacity: _propTypes["default"].number,
    minimumHire: _propTypes["default"].number,
    boatTypes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string
    })),
    medias: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      mediaField: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        path: _propTypes["default"].string
      }))
    }))
  }),
  currency: _propTypes["default"].string,
  item: _propTypes["default"].object,
  booking: _propTypes["default"].object,
  LinkComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  useNoneGatsbyImage: _propTypes["default"].bool,
  hidePrice: _propTypes["default"].bool,
  mediaLoadType: _propTypes["default"].string
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(BoatCard);